import React from 'react';
import { spacerPropTypes } from './SpacerPropTypes';
import * as styles from './Spacer.module.scss';
const Spacer = ({
  variant
}) => {
  if (!variant) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${styles[variant]}`
  });
};
export default Spacer;